<template>
	<div>
		<div class="wrapper1200" style="margin-top: 20px;display: flex;margin-bottom: 88px;">
			<div class="allCategories">
				<div class="category">所有类目</div>
				<div class="consultingService" v-for="(item,index ) in inhBalance" :key="index">
					<div class="ngService flex row-between" @click="showHide(item,index)">
						<div>{{item.name}}</div>
						<img src="../assets/icon/upArrow.png" alt="" v-if="current==index" />
						<img src="../assets/icon/downArrow.png" alt="" v-else />
					</div>
					<ul class="allControl flex" v-show="current == index">
						<li class="serli" v-for="(items,indexs) in econdaryClassi" :key="indexs"
							@click.stop="clitchBalance(items,indexs)" :class="{'acitre':oSwitchBalan==indexs}">
							{{items.name}}
						</li>
					</ul>
				</div>
			</div>

			<div class="olContent">
				<div class="bread">
					<div>中医知识库</div>
					<div>></div>
					<div>{{inhBalance[current].name}}</div>
					<div>></div>
					<div>{{econdaryClassi[oSwitchBalan].name}}</div>
				</div>
				<div class="overallContent">
					<div class="title">{{detailsDisplay.title}}</div>
					<div class="dateser">{{detailsDisplay.createTime}}</div>
					<div class="articleContent">
						{{detailsDisplay.content}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		listClassify,
		knowledgeBase,
		knowledgeBaseDetails
	} from "@/api/api.js"
	export default {
		data() {
			return {
				current: 0,
				oSwitchBalan: 0,
				inhBalance: [],
				econdaryClassi: [{
					name: '全部'
				}],
				contentList: '',
				detailsDisplay: '',

				repositoryId: ''
			}
		},
		created() {
			this.classification()
		},
		mounted() {
			// 获取查询参数
			// 如果是路径参数，假设路由配置为 /some-path/:id
			this.repositoryId = this.$route.query.id
			this.clickOnDetails()
		},
		methods: {
			clickOnDetails() {
				knowledgeBaseDetails({
					repositoryId: this.repositoryId
				}).then(res => {
					this.detailsDisplay = res.data
					console.log(res, '2222222');
				})
			},
			//一级分类
			async classification() {
				await listClassify().then(res => {
					this.inhBalance = res.data
					this.secondaryClassification()
					console.log(res, '2222222');
				})
			},
			//二级分类
			async secondaryClassification() {
				await listClassify({
					superior: this.inhBalance[this.current].classifyId
				}).then(res => {
					this.econdaryClassi.push(...res.data)
					// this.getGoods()
					console.log(res, '2222222');
				})

			},
			showHide(item, index) {
				console.log(index)
				this.current = index
				this.econdaryClassi = [{
					name: '全部'
				}]
				this.oSwitchBalan = 0
				this.secondaryClassification()
				// this.$router.push({
				// 	path: '/knowledgeBase',
				// 	query: {
				// 		current: this.current,
				// 		oSwitchBalan: this.oSwitchBalan
				// 	}
				// })
			},
			clitchBalance(item, index) {
				console.log('123123123')
				// if (index != 0) {
				// 	// this.ider = item.id
				// } else {
				// 	// this.ider = ''
				// }
				this.oSwitchBalan = index
				this.$router.push({
					path: '/knowledgeBase',
					query: {
						current: this.current,
						oSwitchBalan: this.oSwitchBalan
					}
				})
				// this.getGoods();
			},
			// async getGoods() {
			// 	await knowledgeBase({
			// 		primaryClassifyId: this.inhBalance[this.current].classifyId,
			// 		secondaryClassifyId: this.econdaryClassi[this.oSwitchBalan].classifyId
			// 	}).then(res => {
			// 		this.contentList = res.rows
			// 	})
			// }
		}
	}
</script>

<style lang="scss" scoped>
	ul {
		list-style-type: none;
	}

	.defaults {
		text-align: center;
		margin: 0 auto;
		width: 100%;
	}

	.allCategories {
		// width: 220px;
		// flex: 1;
		cursor: default;

		.category {
			width: 202px;
			background: #D89A3A;
			font-size: 16px;
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			color: #FFFFFF;
			line-height: 54px;
			padding-left: 18px;
		}

		.consultingService {
			width: 220px;

			.ngService {
				width: 200px;
				background: #F1F1F1;
				padding: 18px 10px;
				font-size: 15px;
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				color: #333333;

				img {
					width: 22px;
					height: 22px;
				}
			}

			.allControl {
				flex-flow: row wrap;
				padding: 0 10px;
				text-align: center;

				.acitre {
					background: #D89A3A;
					color: #FFFFFF !important;
				}

				.serli {
					height: 30px;
					width: 50%;
					line-height: 30px;
					font-size: 13px;
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: 400;
					color: #666666;
				}
			}
		}
	}

	.olContent {
		margin-left: 20px;
		flex: 1;

		.bread {
			display: flex;
			align-items: center;

			div {
				margin-right: 10px;
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				font-size: 14px;
				color: #666666;
			}
		}

		.overallContent {
			background: #FFFFFF;
			margin-top: 20px;
			padding: 34px 40px;

			.title {
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				font-size: 24px;
				color: #111111;
			}

			.dateser {
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 13px;
				color: #666666;
				margin-top: 18px;
				border-bottom: 1px solid #E1E1E1;
				padding-bottom: 18px;

			}

			.articleContent {
				padding-top: 28px;
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				font-size: 14px;
				color: #333333;
				line-height: 18px;
				text-align: left;
				font-style: normal;
				text-transform: none;
			}
		}
	}
</style>